import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = () => {
  const [stars, setStars] = useState([]);
  const [backgroundImages, setBackgroundImages] = useState([]);

  useEffect(() => {
    const generateStars = () => {
      const starArray = [];
      for (let i = 0; i < 80; i++) {
        starArray.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * 2 + 0.5,
          animationDelay: Math.random() * 5,
          brightness: Math.random() * 0.8 + 0.2,
        });
      }
      setStars(starArray);
    };

    // You can add your night sky images here
    // Save your images in public/assets/ folder and add them to this array
    const images = [
      '/assets/night-sky-1.jpeg', // Your night sky image
       // Add your second night sky image here
      // Add more images as needed
    ];
    setBackgroundImages(images);

    generateStars();
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Main Background Image */}
      {backgroundImages.length > 0 ? (
        <motion.div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('${backgroundImages[0]}')`,
          }}
          animate={{
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ) : (
        // Fallback gradient background if no images are provided
        <div className="absolute inset-0 bg-gradient-to-b from-indigo-950 via-purple-900 to-pink-900" />
      )}

      {/* Secondary Background Image for Animation (if available) */}
      {backgroundImages.length > 1 && (
        <motion.div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('${backgroundImages[1]}')`,
          }}
          animate={{
            opacity: [0, 0.3, 0],
            scale: [1.05, 1, 1.05],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 10,
          }}
        />
      )}

      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/20" />

      {/* Enhanced Twinkling Stars */}
      {stars.map((star) => (
        <motion.div
          key={star.id}
          className="absolute rounded-full bg-white"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: star.brightness,
            boxShadow: `0 0 ${star.size * 3}px rgba(255,255,255,0.6)`,
          }}
          animate={{
            opacity: [star.brightness * 0.3, star.brightness, star.brightness * 0.3],
            scale: [1, 1.5, 1],
          }}
          transition={{
            duration: 3 + Math.random() * 4,
            repeat: Infinity,
            delay: star.animationDelay,
            ease: "easeInOut",
          }}
        />
      ))}

      {/* Shooting Stars */}
      <motion.div
        className="absolute w-1 h-1 bg-white rounded-full"
        style={{ 
          top: '15%', 
          left: '10%',
          boxShadow: '0 0 8px rgba(255,255,255,0.9), 0 0 16px rgba(255,255,255,0.5)',
        }}
        animate={{
          x: [0, 500],
          y: [0, 250],
          opacity: [0, 1, 1, 0],
          scale: [1, 2, 1],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatDelay: 12,
          ease: "easeOut",
        }}
      />
      
      <motion.div
        className="absolute w-1 h-1 bg-white rounded-full"
        style={{ 
          top: '70%', 
          left: '90%',
          boxShadow: '0 0 8px rgba(255,255,255,0.9), 0 0 16px rgba(255,255,255,0.5)',
        }}
        animate={{
          x: [0, -400],
          y: [0, 200],
          opacity: [0, 1, 1, 0],
          scale: [1, 2, 1],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          repeatDelay: 18,
          delay: 6,
          ease: "easeOut",
        }}
      />

      {/* Atmospheric Glow Effects */}
      <motion.div
        className="absolute inset-0 opacity-30"
        animate={{
          background: [
            'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 70% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 20% 70%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 80% 30%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          ],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Subtle breathing effect overlay */}
      <motion.div
        className="absolute inset-0"
        animate={{
          opacity: [0.1, 0.3, 0.1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          background: 'radial-gradient(circle at center, transparent 40%, rgba(139, 69, 19, 0.1) 100%)',
        }}
      />
    </div>
  );
};

export default AnimatedBackground;
